import templateUrl from 'emun.promotion/vendor-promotions.htm'
import templateUrlSlider from "emun.promotion/vendor-promotions-slider.htm";
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import config from "emun.promotion/promotion.config";

class VendorPromotionsController  {
    constructor() {
        const $ctrl = this;
        basicController($ctrl);
		if (!$ctrl.slidesToShow) $ctrl.slidesToShow = [1, 2, 3, 5];
		if (!$ctrl.slidesToScroll) $ctrl.slidesToScroll = [1, 2, 3, 5];
		if (!$ctrl.speed) $ctrl.speed = 500;
		if ($ctrl.arrows !== false) $ctrl.arrows = true;
		if ($ctrl.dots !== true) $ctrl.dots = false;

		$ctrl.vendors = [{
			id: "ALL",
			label: "ALL"
		}];
		$ctrl.uniqueVendorIds = [];

		let options = {
            url: 'QueryPromotions.json?IsActive=1',
			criteria: {
				brandId: $ctrl.brandId,
				tagCriteria: $ctrl.tagCriteria,
			},
            pageSize: 1000,
            autoLoad: true,
            append: false,
            sortOptions: {
                'Id': 'Code: 1 to 9',
                '-Id': 'Code: 9 to 1',
                'Description': 'Description: A to Z',
                '-Description': 'Description: Z to A'
            },
			filters: config.filters,
			hideLeftNav: true,
			onLoaded: function(args) {
				args.results.sort(function (a, b) {
					return a.brand.label.localeCompare(b.brand.label) || a.description.localeCompare(b.description);
				});				
				args.results.forEach(function(obj) {
					obj.handleClicked = (e) => $ctrl.selectedPromo = obj;
				});
				//get vendor list
				if (!$ctrl.uniqueVendorIds.length) {
					args.results.forEach(function(obj) {
						if (obj.brandId) $ctrl.uniqueVendorIds.push(obj.brandId);
					});
					$ctrl.bus.send(`QueryVendors.json?Active=1&OrderBy=Label&IdIn=${$ctrl.uniqueVendorIds}`).then(function(v) {
						v.data.results.map(v => {
							$ctrl.vendors.push(v)
						});
					});
				}
			}
        };
        $ctrl.query = new AutoQuery(options);
        $ctrl.bus = $ctrl.query.bus;
    }
	load() { return this.query.load(); }
	viewAll() {
		const $ctrl = this;
		$ctrl.selectedPromo = {};
	}
	selectVendor(v) {
		const $ctrl = this;
		if (v.id == "ALL") $ctrl.query.criteria.brandId = undefined;
		else $ctrl.query.criteria.brandId = v.id;
		$ctrl.query.load();
	}

}

let VendorPromotions = {
    controller: VendorPromotionsController,
	bindings: {
		brandId: "@",
		showMenu: "<?",
		tagCriteria: "<?",
	},
    templateUrl($element, $attrs) {
		return $attrs.templateUrl || $attrs.type === "slider" ? templateUrlSlider : templateUrl;
    }
}

export default VendorPromotions;
